import React from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { Private, Private as ROUTES } from '#/containers/router/routes/Private';

import { SectionProps } from '../Sections';

interface AgenciesProps extends SectionProps {}

export const Agencies: React.FC<AgenciesProps> = ({ onClickItem, isMobile, depth }) => {
  const { t } = useI18n();

  return (
    <Can hasRoles={['admin']}>
      <NavigationLink
        to={Private.AGENCIES.route}
        isMobile={isMobile}
        onClick={onClickItem}
        depth={depth}
        title={t('general.agencies')}
        icon="building"
      />
    </Can>
  );
};
